import React from "react";
import { useNavigate } from "react-router-dom";
import HumiditePlisBoxplot from "./HumiditePlisBoxplot";

import { useI18n } from "../i18n/I18nContext";

const S = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(160deg,#041e2e 0%,#063549 60%,#052a3e 100%)",
    color: "#e2e8f0",
    fontFamily: "Inter, sans-serif",
    padding: "24px 28px",
  },
  wrap: {
    maxWidth: 1600,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 12,
  },
  title: {
    fontSize: 26,
    fontWeight: 900,
    background: "linear-gradient(90deg,#fff,#E6FF3E)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  subtitle: {
    fontSize: 13,
    color: "#94a3b8",
    marginTop: 4,
  },
  backBtn: {
    padding: "9px 18px",
    borderRadius: 8,
    border: "1px solid #1e3a50",
    background: "rgba(255,255,255,0.04)",
    color: "#cbd5e1",
    cursor: "pointer",
    fontWeight: 700,
    fontSize: 13,
  },
};

export default function HumiditePlisPage() {
  const { t, ui } = useI18n();

  const navigate = useNavigate();

  return (
    <div style={S.page}>
      <div style={S.wrap}>
        <div style={S.header}>
          <div>
            <div style={S.title}>Humidité des plis</div>
            <div style={S.subtitle}>
              Banc de test · Conditionnement · Imprégnation · Séchage
            </div>
          </div>
          <button type="button" style={S.backBtn} onClick={() => navigate(-1)}>
            {ui("Retour")}
          </button>
        </div>

        <HumiditePlisBoxplot active />
      </div>
    </div>
  );
}
